import { render, staticRenderFns } from "./TalentMatrixEditDialog.vue?vue&type=template&id=51603d54&scoped=true"
import script from "./TalentMatrixEditDialog.vue?vue&type=script&lang=js"
export * from "./TalentMatrixEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51603d54",
  null
  
)

export default component.exports